import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontWeight: 700,
  },
  subTitle: {
    fontWeight: 400,
    fontSize: 'normal',
    opacity: 0.8,
  },
}));

export default useStyles;
